export const KIROV_STATION_ID = '27199'
export const WEATHER_STATION_KEY = 'weatherSelectedStation'

export interface WeatherCurrent {
  phenomenon_title_t?: string
  t_air_t?: number | string
  humidity_t?: number | string
  pressure_t?: number | string
  wind_direction_t?: string
  wind_speed_t?: number | string
  dt?: string
  tm?: string
  skycon?: string
  emoji?: string
}

export interface WeatherForecastPart {
  wind_dir?: string
  wind_speed?: string | number
  temp_min?: string | number
  temp_max?: string | number
  phenomena?: string
  cloudiness?: string
  icon?: string
  emoji?: string
  temp?: string
  desc?: string
  wind?: string
}

export interface WeatherForecastDay {
  dt?: string
  tp?: string
  night?: WeatherForecastPart
  day?: WeatherForecastPart
  sunrise?: string
  sunset?: string
  date?: string
}

export interface HeaderWeather {
  current: WeatherCurrent
  today: WeatherForecastDay | null
}

export interface WeatherStation {
  id: string
  name: string
}

export interface WeatherReading {
  recorded_at: string
  t_air?: number | null
  pressure?: number | null
  humidity?: number | null
}

export interface WeatherReadingsResponse {
  readings: WeatherReading[]
  stats: {
    min_temp?: number | null
    max_temp?: number | null
    avg_pressure?: number | null
    avg_humidity?: number | null
  } | null
}

export type WeatherPeriodDays = 1 | 7 | 30
